export default __webpack_public_path__ + "static/media/Pools.f8ea5151.svg";